<template>
  <b-col sm="5 mt-5">
    <img src="/img/logo-aid.png" />
    <h5 class="text-white mt-5">
      Questa piattaforma vuole essere uno strumento per superare le barriere linguistiche e il suo fine è aiutare a
      comunicare nelle situazioni di emergenza, quando la conoscenza diventa un fattore fondamentale per la sicurezza di
      tutti.
      <br /><br />
      Stiamo facendo un grande sforzo per renderla utilizzabile da tutti senza alcuna limitazione.
      <br /><br />
      Il contributo di associazioni, enti, ecc. e dei volontari madrelingua è fondamentale.
    </h5>
    <!-- <a class="languageaid" href="https://languageaidodv.org/" target="blank"><h5>LanguageAid ODV</h5></a> -->
  </b-col>
</template>
<script>
export default {
  name: "HomeText",
};
</script>

<style>
.languageaid {
  color: white !important;
}
.languageaid:hover {
  color: #f49538 !important;
}
</style>
